export const categories = [
    {
        id: 1,
        slug: 'ac-cleaning',
        img: '/Assets/ac-cleaning.jpg',
        heading: 'AC Cleaning',
        description: 'Al-Nayazak reflects our motive to add value in our customers life by providing all required services in their daily and working lives, decrease unemployment from Dubai by hiring in house staff whom we train and give skills.'
    },
    {
        id: 2,
        slug: 'ac-services',
        img: '/Assets/ac-service.jpg',
        heading: 'AC Services',
        description: 'Al-Nayazak reflects our motive to add value in our customers life by providing all required services in their daily and working lives, decrease unemployment from Dubai by hiring in house staff whom we train and give skills.'
    },
    {
        id: 3,
        slug: 'ac-repairing',
        img: '/Assets/acRepairing.jpg',
        heading: 'AC Repairing',
        description: 'Al-Nayazak reflects our motive to add value in our customers life by providing all required services in their daily and working lives, decrease unemployment from Dubai by hiring in house staff whom we train and give skills.'
    },
    {
        id: 1,
        slug: 'painting',
        img: '/Assets/painting.jpg',
        heading: 'Painting',
        description: 'Al-Nayazak reflects our motive to add value in our customers life by providing all required services in their daily and working lives, decrease unemployment from Dubai by hiring in house staff whom we train and give skills.'
    },
];